__turbopack_context__.v({
  "infoParagraph": "XynvoW_infoParagraph",
  "newMainBooker": "XynvoW_newMainBooker",
  "participantLabel": "XynvoW_participantLabel",
  "priceLoader": "XynvoW_priceLoader",
  "priceSummary": "XynvoW_priceSummary",
  "priceValue": "XynvoW_priceValue",
});
